import type { ReactNode } from "react";
import { useControlBarLabelPosition } from "./Internal/ControlBarLabelContext";

export function ControlBarItem({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) {
  // Label placement is driven by the enclosing bar's context (set once per
  // bar), never per-item — so a filter row stays consistent rather than a
  // mishmash of beside/above labels.
  const labelPosition = useControlBarLabelPosition();

  if (labelPosition === "above") {
    return (
      <div className="flex flex-col gap-1">
        <span className="text-xs font-semibold whitespace-nowrap text-content">
          {label}
        </span>
        {children}
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1.5">
      <span className="text-xs font-semibold whitespace-nowrap text-content">
        {label}
      </span>
      {children}
    </div>
  );
}
